// search.js

document.addEventListener('DOMContentLoaded', function() {
    // Получаем элемент результатов поиска
    const searchResults = document.querySelector('#gf-products');

    // Если элемент найден, скрываем результаты на 2.5 секунды
    if (searchResults) {
        setTimeout(function(){
            searchResults.classList.remove('hidden-results');
        }, 2500);
    }
});
